export const parseFilters = (filters)=>Object.entries(filters).filter(([, value])=>!!value || value === 0).map(([key, value])=>`${key}=${value}`).join('&');

//# sourceMappingURL=url.js.map